import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { RecruitmentOfferService } from '../../../core/services/recruitment-offer.service';
import { LoadingComponent } from '../../components/loading/loading.component';

@Component({
  selector: 'app-recruitment-list',
  templateUrl: './recruitment-list.component.html',
  imports: [CommonModule, RouterModule, LoadingComponent]
})
export class RecruitmentListComponent {
  offers: any[] = [];
  loading = false;
  error = false;

  constructor(private offerService: RecruitmentOfferService) {}

  ngOnInit(): void {
    this.getAll();
  }

  getAll() {
    this.loading = true;
    this.error = false;
    this.offerService.publicGetAll().subscribe((res: any) => {
      this.loading = false;
      this.offers = res.data ?? [];
    }, () => { this.loading = false; this.error = true; });
  }
}
